var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6252 18.7188C10.6252 18.7188 9.40647 21.4688 9.25022 24C9.21897 24.2813 9.53147 24.5 9.78147 24.375C10.094 24.25 10.5315 24.0938 10.9377 24C11.1877 23.9375 11.4065 24.125 11.4065 24.375C11.4065 25.3437 11.4377 27.625 12.0315 29.1563H20.0002H27.969C28.5315 27.625 28.594 25.3437 28.594 24.375C28.594 24.125 28.8127 23.9375 29.0627 24C29.469 24.0938 29.8752 24.25 30.219 24.375C30.5002 24.4687 30.7815 24.2813 30.7502 24C30.5627 21.4688 29.3752 18.7188 29.3752 18.7188H10.6252Z",
    fill: "url(#paint0_radial_536_3024)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 5C26.0312 3.84375 23.3437 2.5 20 2.5C16.6562 2.5 13.9688 3.84375 12.25 5C10.9063 5.9375 10.0938 7.46875 10.0938 9.125V16L19.7812 16.0625L29.875 16V9.125C29.875 7.46875 29.0937 5.9375 27.75 5Z",
    fill: "url(#paint1_radial_536_3024)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1562 27.5938H13.8437C10.4375 27.5938 7.6875 30.3437 7.6875 33.75C7.6875 35.0937 7.96875 35.75 10.1562 36.2187C10.1562 36.2187 17.5 37.5 20 37.5C22.5 37.5 29.8438 36.2187 29.8438 36.2187C32.0313 35.75 32.3125 35.125 32.3125 33.75C32.2813 30.3437 29.5312 27.5938 26.1562 27.5938Z",
    fill: "url(#paint2_linear_536_3024)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 25V28.375C16.3125 30.4063 17.9687 32.0625 20 32.0625C22.0312 32.0625 23.6875 30.4063 23.6875 28.375V25.0312L16.3125 25Z",
    fill: "url(#paint3_linear_536_3024)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 27.2499C26.7501 27.2499 28.2501 21.8437 28.5626 19.2812C31.9376 19.1562 31.8751 14.0937 28.5626 14.0937C28.5626 13.3749 27.4063 9.21868 25.2188 9.24993C23.9063 9.24993 21.3126 10.1562 20.0001 10.1562C18.6876 10.1562 16.0938 9.24993 14.7813 9.24993C12.5938 9.21868 11.4376 13.3749 11.4376 14.0937C8.12505 14.0937 8.06255 19.1562 11.4376 19.2812C11.7501 21.8124 13.2501 27.2499 20.0001 27.2499Z",
    fill: "url(#paint4_radial_536_3024)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1562 16.9062C16.8121 16.9062 17.3437 16.3746 17.3437 15.7187C17.3437 15.0629 16.8121 14.5312 16.1562 14.5312C15.5004 14.5312 14.9688 15.0629 14.9688 15.7187C14.9688 16.3746 15.5004 16.9062 16.1562 16.9062Z",
    fill: "url(#paint5_linear_536_3024)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8438 16.9062C24.4996 16.9062 25.0312 16.3746 25.0312 15.7187C25.0312 15.0629 24.4996 14.5312 23.8438 14.5312C23.1879 14.5312 22.6562 15.0629 22.6562 15.7187C22.6562 16.3746 23.1879 16.9062 23.8438 16.9062Z",
    fill: "url(#paint6_linear_536_3024)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_536_3024",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.22881 17.6561) scale(25.4348)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#866C62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0596583,
    stopColor: "#7C655C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2224,
    stopColor: "#68554F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4072,
    stopColor: "#5A4A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6308,
    stopColor: "#524441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F423F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_536_3024",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.2116 2.4365) scale(24.9854 24.9854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#866C62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0596583,
    stopColor: "#7C655C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2224,
    stopColor: "#68554F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4072,
    stopColor: "#5A4A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6308,
    stopColor: "#524441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F423F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_536_3024",
    x1: 20,
    y1: 37.5,
    x2: 20,
    y2: 27.6071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0485A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_536_3024",
    x1: 20,
    y1: 32.074,
    x2: 20,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2AD8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1849,
    stopColor: "#EEA788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#E49779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#D47D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9497,
    stopColor: "#BF5C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_536_3024",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.43054 8.95491) scale(22.538 26.5879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2AD8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4703,
    stopColor: "#F1AB8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6503,
    stopColor: "#EDA485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#E7987A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#DE876B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9771,
    stopColor: "#D37157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_536_3024",
    x1: 14.5481,
    y1: 14.3139,
    x2: 16.6509,
    y2: 16.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_536_3024",
    x1: 22.2875,
    y1: 14.2408,
    x2: 24.3244,
    y2: 16.1807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.77248de7c85d69b99ce144534a03de0c.svg";
export { ForwardRef as ReactComponent };